<template>
    <div class="px-4 h-6 m-2 rounded-full text-xs font-semibold flex items-center cursor-pointer"
         :class="`bg-${color}-100 text-${color}-700 hover:bg-${color}-500 hover:text-white`">
        <span v-if="showDot" class="w-2 h-2 rounded-full mr-1" :class="`bg-${color}-400`"></span>
        <slot></slot>
        <font-awesome-icon v-if="showRemove" icon="times-circle" class="text-xl ml-2 object-right" @click="$emit('close')" />
    </div>
</template>
<script>
    export default {
        name: "LBadge",
        props: {
            color: {
                type: String,
                default: "teal"
            },
            showDot: {
                type: Boolean,
                default: true
            },
            showRemove: {
                type: Boolean,
                default: false
            },
            id: {
                type: String                
            },

        }
    };
</script>

<style lang="postcss">
    
</style>
